import { api } from "../services/api";

export function Header() {
  const handleYandexLogin = () => {
    api.yandexLogin();
  };

  return (
    <header className="App-header">
      <div className="header-left">
        <img src="logo.svg" alt="Логотип" className="logo" />
        <h1>Генератор email подписи</h1>
      </div>
      <button onClick={handleYandexLogin} className="yandex-login-btn">
        Заполнить через Яндекс-аккаунт
      </button>
    </header>
  );
}
